import React from "react";
import { useServiceWorker } from "../hooks/useServiceWorker";

/**
 * Fixed bottom banner — appears when a new service worker has installed and
 * is waiting to take over. Clicking "Update now" calls skipWaiting on the
 * waiting SW then reloads the page.
 */
export const UpdateBanner: React.FC = () => {
  const { updateReady, applyUpdate } = useServiceWorker();

  if (!updateReady) return null;

  return (
    <div style={styles.banner} role="status" aria-live="polite">
      <span>A new version of Kaagazy EMR is available.</span>
      <button onClick={applyUpdate} style={styles.button}>
        Update now
      </button>
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  banner: {
    position:        "fixed",
    bottom:          0,
    left:            0,
    right:           0,
    zIndex:          9998,
    display:         "flex",
    alignItems:      "center",
    justifyContent:  "center",
    gap:             16,
    padding:         "12px 16px",
    backgroundColor: "#0f766e",
    color:           "#f0fdfa",
    fontSize:        14,
    fontWeight:      500,
    boxShadow:       "0 -2px 8px rgba(0,0,0,0.15)",
  },
  button: {
    padding:         "6px 18px",
    backgroundColor: "#f0fdfa",
    color:           "#0f766e",
    border:          "none",
    borderRadius:    4,
    fontWeight:      600,
    cursor:          "pointer",
    fontSize:        14,
  },
};
